<app-header-v3></app-header-v3>
<!-- HeaderV2Component stays mounted but visually hidden (see styles.css's
     .hv2-legacy-hidden) — its own bar is replaced by app-header-v3 above,
     but its class-config modal (#class-config-popup) and TC-generation
     modal (#modalTc) must keep working exactly as before, and both live
     inside this component's template. See header-v3.component.ts's class
     comment for the full rationale. -->
<app-header-v2 class="hv2-legacy-hidden"></app-header-v2>
<router-outlet></router-outlet>
<app-menu></app-menu>
